
import React from 'react';
import { Wand } from 'lucide-react';

const ProcessSteps = () => {
  const steps = [
    {
      number: "01",
      title: "Briefing & Analyse",
      description: "Wir verstehen Ihre Marke, Ziele und Zielgruppe für eine maßgeschneiderte Strategie."
    },
    {
      number: "02",
      title: "Unser Team erstellt dein Video",
      description: "Unser Expertenteam nutzt KI-Werkzeuge, um ein maßgeschneidertes Video basierend auf Ihren Anforderungen zu entwickeln – mit perfektem Storytelling."
    },
    {
      number: "03",
      title: "Optimierung & Feedback",
      description: "Sie erhalten einen Link zum Video und können Feedback geben. Wir nehmen Änderungen vor, bis Sie zufrieden sind."
    },
    {
      number: "04",
      title: "Fertigstellung & Integration",
      description: "Nach Ihrer Freigabe erhalten Sie das finale Video für all Ihre Social-Media-Kanäle."
    }
  ];
  
  return (
    <section className="py-20 bg-[#070709] relative overflow-hidden">
      {/* Grid pattern background */}
      <div className="absolute inset-0 bg-[url('/images/grid.svg')] bg-repeat opacity-5"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-future text-white mb-6">
            So funktioniert's
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-900 to-blue-900 mx-auto mb-6"></div>
          <p className="text-gray-300 max-w-2xl mx-auto">
            In nur vier einfachen Schritten zu Ihrem maßgeschneiderten Social-Media-Video
          </p>
        </div>
        
        <div className="relative">
          {/* Connection line */}
          <div className="absolute left-[50%] transform -translate-x-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-purple-600/50 via-purple-500/30 to-transparent hidden lg:block"></div>
          
          <div className="space-y-24">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Timeline dot */}
                <div className="hidden lg:block absolute left-[50%] transform -translate-x-1/2 w-8 h-8 rounded-full bg-purple-900 border-4 border-[#070709]">
                  <div className="absolute inset-0 rounded-full bg-purple-500 animate-ping opacity-30"></div>
                </div>
                
                <div className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center`}>
                  {/* Step number */}
                  <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right lg:pr-16' : 'lg:text-left lg:pl-16'} mb-6 lg:mb-0`}>
                    <span className="text-6xl font-bold text-purple-800/40 font-future">{step.number}</span>
                  </div>
                  
                  {/* Step content */}
                  <div className="flex-1 max-w-md">
                    <div className="bg-[#111116] border border-purple-900/20 rounded-xl p-6 hover:transform hover:translate-y-[-5px] transition-transform duration-300">
                      <h3 className="text-xl font-semibold text-white mb-3">{step.title}</h3>
                      <p className="text-gray-400">{step.description}</p>
                      
                      {index === 1 && (
                        <div className="mt-4 flex items-center justify-center">
                          <div className="w-12 h-12 rounded-full bg-purple-900/30 flex items-center justify-center relative overflow-hidden">
                            <Wand size={24} className="text-purple-400 relative z-10" />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
